module.exports = __webpack_public_path__ + "static/media/carDefault.205de873.png";